//FINAL_UNDO
//---------------
var UnReId,ReUnId,arr,json,newBg,newRing,lastAdded,reBase,reChipName,reNewBg,reNewRing,reJson,lastRound,lastChip,lastColor;
function undo(num){
  var lastIndex = window['universal'+num].at(-1),
      indexType = lastIndex.substr(6,8),
      addNew = lastIndex.substr(lastIndex.length - 6);
  if(indexType === 'chipColo' || indexType === 'overlay'+num || indexType === 'bckgrnd'+num || indexType === 'path-gro' || indexType === 'curvedTe'){
    if(indexType === 'chipColo'){
      if(firstC != 'done'){
        undoBtn.setAttribute('data-first','done');
        window['cColor'+num].splice(-1);
      }
      base = window['cColor'+num].at(-1);
      updateChipColor(base);
      window['cColor'+num].splice(-1);
      reBase = jQuery('input[name="pro_color"]:checked').attr('data-color');
      jQuery('input[name="pro_color"][data-color="'+base+'"]').prop('checked',true);
      arr = 1;
      if(num === '1'){
        arr = 2;
      }
      lastChip = findLastChip(indexType,window['universal'+arr]);
      lastColor = findLastChip(base,window['universal'+arr]);
      window['cColor'+arr].splice(lastColor,1);
      window['universal'+arr].splice(lastChip,1);
      window['universal'+num].splice(-1);
      if(window['cColor'+num].length < 1){
        window['cColor'+num].push('#000000');
        window['universal'+num].push('type: chipColor'+num);
      }
      re_universalFlow(num,lastIndex);
      re_universalFlow(arr,lastIndex);
      re_cColorState(num,reBase);
      re_cColorState(arr,reBase);
    }
    if(indexType === 'overlay'+num){
      if(firstC != 'done'){
        undoBtn.setAttribute('data-first','done');
        window['overlayBg'+num].splice(-1);
      }
      chipName = window['overlayBg'+num].at(-1);
      checkChipColor(chipName);
      addShape(num,'#000000');
      window['overlayBg'+num].splice(-1);
      reChipName = jQuery('input[name="chips"]:checked').val();
      jQuery('input[name="chips"][value="'+chipName+'"]').prop('checked',true);
      arr = 1;
      if(num === '1'){
        arr = 2;
      }
      lastChip = findLastChip(indexType,window['universal'+arr]);
      lastColor = findLastChip(chipURL,window['universal'+arr]);
      window['overlayBg'+arr].splice(lastColor,1);
      window['universal'+arr].splice(lastChip,1);
      window['universal'+num].splice(-1);
      if(window['overlayBg'+num].length < 1){
        window['overlayBg'+num].push('spot_8');
        window['universal'+num].push('type: overlay'+num);
      }
      re_overlayState(num);
      re_overlayState(arr);
      re_universalFlow(num,lastIndex);
      re_universalFlow(arr,lastIndex);
    }
    if(indexType === 'bckgrnd'+num){
      if(firstC != 'done'){
        undoBtn.setAttribute('data-first','done');
        window['canvasBgd'+num].splice(-1);
      }
      newBg = window['canvasBgd'+num].at(-1);
      reNewBg = window['canv_'+num].backgroundColor;
      window['canv_'+num].backgroundColor = newBg;
      if(window['ring_'+num].paths[1]){
        window['ring_'+num].paths[1].setFill(newBg);
      }
      window['canv_'+num].renderAll();
      jQuery('#bgColor .currentColor').val(newBg);
      jQuery('#bgColor .currentColor+.colorBox').css('backgroundColor',newBg);
      window['canvasBgd'+num].splice(-1);
      window['universal'+num].splice(-1);
      if(window['canvasBgd'+num].length < 1){
        window['canvasBgd'+num].push('#ffffff');
        window['universal'+num].push('type: bckgrnd'+num);
      }
      re_backgroundState(num);
      re_universalFlow(num,lastIndex);
    }
    if(indexType === 'path-gro'){
      if(addNew === 'ring-0' || addNew === 'ring-1' || addNew === 'ring-2'){
        window['universal'+num].splice(-1);
        lastRound = lastIndex.slice(0,-1);
        lastChip  = findLastRound(lastRound,window['universal'+num]);
        lastRound = window['universal'+num][lastChip];
        lastRound = lastRound.substr(lastRound.length - 6);
        jQuery('input[name="rounders"][value="'+lastRound+'"]').prop('checked',true).change();
        window['universal'+num].splice(-1);
      }
      else{
        if(firstC != 'done'){
          undoBtn.setAttribute('data-first','done');
          window['chipRing'+num].splice(-1);
        }
        newRing = window['chipRing'+num].at(-1);
        reNewRing = window['ring_'+num].paths[0].fill;
        window['ring_'+num].paths[0].setFill(newRing);
        window['canv_'+num].renderAll();
        jQuery('#ringColor .currentColor').val(newRing);
        jQuery('#ringColor .currentColor+.colorBox').css('backgroundColor',newRing);
        window['chipRing'+num].splice(-1);
        window['universal'+num].splice(-1);
        re_chipRing(num);
      }
      re_universalFlow(num,lastIndex);  
    }
    if(indexType === 'curvedTe'){
      UnReId = lastIndex.split(' id: ')[1];
      UnReId = UnReId.split(',')[0];
      reJson = window['curvedTxt'+num+'_'+UnReId].at(-1);
      if(firstC != 'done'){
        undoBtn.setAttribute('data-first','done');
        re_textCurved(UnReId,num,reJson);
        window['curvedTxt'+num+'_'+UnReId].splice(-1);
      }
      json = window['curvedTxt'+num+'_'+UnReId].at(-1);
      if(addNew === 'addNew'){
        Objects = window['canv_'+num].getObjects();
        activeOb = window['canv_'+num].getActiveObject();
        if(!activeOb){
          Objects.forEach(function(obj){
            objId = obj.id;
            if(objId === UnReId){
              window['canv_'+num].setActiveObject(obj);
            }
          });
          jQuery('#effect').val('straight').change();
          window['canv_'+num].discardActiveObject().renderAll();
        }else{
          jQuery('#effect').val('straight').change();
        }
        window['textImage'+num+'_'+UnReId].splice(-1);
        undoBtn.setAttribute('data-first','');
        window['universal'+num].splice(-1);
      }else{
        console.log(json);
        loadObject(num,json);
      }
      window['curvedTxt'+num+'_'+UnReId].splice(-1);
      window['universal'+num].splice(-1);
      re_textCurved(UnReId,num,json);
      re_universalFlow(num,lastIndex);
    }
    jQuery('#undo').prop('disabled', false);
    jQuery('#redo').prop('disabled', false);
    if(window['universal'+num].length < 2){
      jQuery('#undo').prop('disabled', true);
    }
  }else{
    UnReId = lastIndex.split(' id: ')[1];
    UnReId = UnReId.split(',')[0];
    reJson = window['textImage'+num+'_'+UnReId].at(-1);
    if(firstC != 'done'){
      undoBtn.setAttribute('data-first','done');
      re_textImage(UnReId,num,reJson);
      window['textImage'+num+'_'+UnReId].splice(-1);
    }
    json = window['textImage'+num+'_'+UnReId].at(-1);
    if(addNew === 'addNew'){
      Objects = window['canv_'+num].getObjects();
      Objects.forEach(function(obj){
        objId = obj.id;
        if(objId === UnReId){
          reJson = obj.toJSON(['selectable', 'id']);
          window['canv_'+num].remove(obj).renderAll();
          jQuery('.layerObject[data-for="'+objId+'"]').remove();
          jQuery('.updateImage').hide();
          re_textImage(UnReId,num,reJson);
          window['re_textImage'+num+'_'+UnReId].splice(-1);
          reJson = window['textImage'+num+'_'+UnReId].at(-1);
        }
      });
    }else{
      loadObject(num,json);
    }
    re_universalFlow(num,lastIndex);
    re_textImage(UnReId,num,json);
    if(typeof window['textImage'+num+'_'+id] !== "undefined"){
       window['textImage'+num+'_'+id].splice(-1);
    }
    if(Array.isArray(window['universal'+num])){
    	window['universal'+num].splice(-1);
    }
    jQuery('#undo').prop('disabled', false);
    jQuery('#redo').prop('disabled', false);
    if(window['universal'+num].length < 2){
      jQuery('#undo').prop('disabled', true);
    }
  }
}

function onObjectModified(num,object){
  if(object){
    if(object === 'overlayChipColor'){
      lastModified = 'chipColor'+num;
      cColorState(num);
    }
    else if(object === 'overlayImage'){
      lastModified = 'overlay'+num;
      overlayState(num);
    }
    else if(object === 'background'){
      lastModified = 'bckgrnd'+num;
      backgroundState(num);
    }
    else{
      lastModified = object.type;
      id = object.id;
      if(lastModified === 'curvedText'){
        if(newlyAd && !window['curvedTxt'+num+'_'+id]){
          window['curvedTxt'+num+'_'+id] = [];
          window['re_curvedTxt'+num+'_'+id] = [];
        }
        textCurved(id,num,object);
      }else if(lastModified === 'path-group'){
        if(newRounder != 'ring-0'){
          chipRing(num);
        }
      }else{
        if(newlyAd && !window['textImage'+num+'_'+id]){
          window['textImage'+num+'_'+id] = [];
          window['re_textImage'+num+'_'+id] = [];
        }
        textImage(id,num,object);
      }
    }       
    universalFlow(num,lastModified);
  }
}

function universalFlow(num,lastModified){
  var action = window['universal'+num].length;
  if(action > 19){
    window['universal'+num].shift();
  }
  var array = 'type: '+lastModified;
  if(lastModified === 'text' || lastModified === 'curvedText' || lastModified === 'image'){
    array = array+', id: '+id;
    if(lastModified === 'text' && action > 19 || lastModified === 'image' && action > 19){
      window['textImage'+num+'_'+id].shift();
    }else if(lastModified === 'curvedText' && action > 19){
      window['curvedTxt'+num+'_'+id].shift();
    }
  }
  else if(lastModified === 'chipColor'+num){
    if(lastModified === 'chipColor'+num && action > 19){
      window['cColor'+num].shift();
    }
  }
  else if(lastModified === 'overlay'+num){
    if(lastModified === 'overlay'+num && action > 19){
      window['overlayBg'+num].shift();
    }
  }
  else if(lastModified === 'bckgrnd'+num){
    if(lastModified === 'bckgrnd'+num && action > 19){
      window['canvasBgd'+num].shift();
    }
  }
  else if(lastModified === 'path-group'){
    if(lastModified === 'path-group' && action > 19){
      window['chipRing'+num].shift();
    }
  }
  if(added){
    added = false;
    if(lastModified === 'path-group'){
      array = array+', '+newRounder;
    }else{
      array = array +', addNew';
    }
  }
  window['universal'+num].push(array);
}

function cColorState(num){
  base = jQuery('input[name="pro_color"]:checked').attr('data-color');
  window['cColor'+num].push(base);
}

function overlayState(num){
  chipName = jQuery('input[name="chips"]:checked').attr('value');
  window['overlayBg'+num].push(chipName);
}         

function backgroundState(num){
  window['canvasBgd'+num].push(window['canv_'+num].backgroundColor);
}

function chipRing(num){
  window['chipRing'+num].push(window['ring_'+num].paths[0].fill);
}

function textCurved(id,num,object){
  obj = object.toJSON(['selectable', 'id']);
  window['curvedTxt'+num+'_'+id].push(obj);
}

function textImage(id,num,object){
  obj = object.toJSON(['selectable', 'id']);
  window['textImage'+num+'_'+id].push(obj);
}

function findLastChip(value,arr){
  var result = 0;
  for(var i = 0; i< arr.length; i++){
    var name = arr[i];
    if(name === value){
      result = i;
    }
  }
  return result;
}

function findLastRound(value,arr){
  var result = 0;
  for(var i = 0; i< arr.length; i++){
    var name = arr[i];
    if(name.indexOf(value) > -1){
      result = i;
    }
  }
  return result;
}
     
     
//FINAL_REDO
//---------------
function redo(num){
  var lastIndex = window['re_universal'+num].at(-1),
      indexType = lastIndex.substr(6,8),
      addNew = lastIndex.substr(lastIndex.length - 6);
  if(indexType === 'chipColo' || indexType === 'overlay'+num || indexType === 'bckgrnd'+num || indexType === 'path-gro' || indexType === 'curvedTe'){
    if(indexType === 'chipColo'){
      undoBtn.setAttribute('data-first','');
      base = window['re_cColor'+num].at(-1);
      updateChipColor(base);
      window['re_cColor'+num].splice(-1);
      jQuery('input[name="pro_color"][data-color="'+base+'"]').prop('checked',true);
      arr = 1;
      if(num === '1'){
        arr = 2;
      }
      lastChip = findLastChip(indexType,window['re_universal'+arr]);
      lastColor = findLastChip(base,window['re_universal'+arr]);
      window['re_cColor'+arr].splice(lastColor,1);
      window['re_universal'+arr].splice(lastChip,1);
      window['re_universal'+num].splice(-1);
      lastIndex = lastIndex.slice(6);
      universalFlow(num,lastIndex);
      universalFlow(arr,lastIndex);
      base = reBase;
      cColorState(num);
      cColorState(arr);
    }
    if(indexType === 'overlay'+num){
      undoBtn.setAttribute('data-first','');
      chipName = window['re_overlayBg'+num].at(-1);
      checkChipColor(chipName);
      addShape(num,'#000000');
      window['re_overlayBg'+num].splice(-1);
      reChipName = jQuery('input[name="chips"]:checked').val();
      jQuery('input[name="chips"][value="'+chipName+'"]').prop('checked',true);
      arr = 1;
      if(num === '1'){
        arr = 2;
      }
      lastChip = findLastChip(indexType,window['re_universal'+arr]);
      lastColor = findLastChip(chipURL,window['re_universal'+arr]);
      window['re_overlayBg'+arr].splice(lastColor,1);
      window['re_universal'+arr].splice(lastChip,1);
      window['re_universal'+num].splice(-1);
      chipName = reChipName;
      lastIndex = lastIndex.slice(6);
      overlayState(num);
      overlayState(arr);
      universalFlow(num,lastIndex);
      universalFlow(arr,lastIndex);
    }
    if(indexType === 'bckgrnd'+num){
      undoBtn.setAttribute('data-first','');
      reNewBg = window['re_canvasBgd'+num].at(-1);
      newBg = window['canv_'+num].backgroundColor;
      window['canv_'+num].backgroundColor = reNewBg;
      if(window['ring_'+num].paths[1]){
        window['ring_'+num].paths[1].setFill(reNewBg);
      }
      window['canv_'+num].renderAll();
      jQuery('#bgColor .currentColor').val(reNewBg);
      jQuery('#bgColor .currentColor+.colorBox').css('backgroundColor',reNewBg);
      window['re_canvasBgd'+num].splice(-1);
      window['re_universal'+num].splice(-1);
      backgroundState(num);
      lastIndex = lastIndex.slice(6);
      universalFlow(num,lastIndex);
    }
    if(indexType === 'path-gro'){
      undoBtn.setAttribute('data-first','');
      if(addNew === 'ring-0' || addNew === 'ring-1' || addNew === 'ring-2'){
        lastRound = lastIndex.slice(0,-1);
        lastChip = findLastRound(lastRound,window['re_universal'+num]);
        lastRound = window['re_universal'+num][lastChip];
        lastRound = lastRound.substr(lastRound.length - 6);
        jQuery('input[name="rounders"][value="'+lastRound+'"]').prop('checked',true).change();
        window['re_universal'+num].splice(-1);
      }else{
        reNewRing = window['re_chipRing'+num].at(-1);
        newRing = window['ring_'+num].paths[0].fill;
        window['ring_'+num].paths[0].setFill(reNewRing);
        window['canv_'+num].renderAll();
        jQuery('#ringColor .currentColor').val(reNewRing);
        jQuery('#ringColor .currentColor+.colorBox').css('backgroundColor',reNewRing);
        window['re_chipRing'+num].splice(-1);
        window['re_universal'+num].splice(-1);
        chipRing(num);
        lastIndex = lastIndex.slice(6);
        universalFlow(num,lastIndex);
      }
    }
    if(indexType === 'curvedTe'){
      ReUnId = lastIndex.split(' id: ')[1];
      ReUnId = ReUnId.split(',')[0];
      json = window['re_curvedTxt'+num+'_'+ReUnId].at(-1);
      Objects = window['canv_'+num].getObjects();
      if(firstC === 'done' && addNew != 'addNew'){
        undoBtn.setAttribute('data-first','');
        Objects.forEach(function(obj){
          objId = obj.id;
          if(objId === ReUnId){
            textCurved(ReUnId,num,obj);
          }
        });
        loadObject(num,json);
        window['re_curvedTxt'+num+'_'+ReUnId].splice(-1);
        json = window['re_curvedTxt'+num+'_'+ReUnId].at(-1);
      }
      if(addNew === 'addNew'){
        undoBtn.setAttribute('data-first','');
        Objects = window['canv_'+num].getObjects();
        activeOb = window['canv_'+num].getActiveObject();
        if(!activeOb){
          Objects.forEach(function(obj){
            objId = obj.id;
            if(objId === ReUnId){
              window['canv_'+num].setActiveObject(obj);
            }
          });
          jQuery('#effect').val('effect').change();
          window['canv_'+num].discardActiveObject().renderAll();
        }else{
          jQuery('#effect').val('effect').change();
        }
        window['re_curvedTxt'+num+'_'+ReUnId].splice(-1);
        undoBtn.setAttribute('data-first','');
        window['re_universal'+num].splice(-1);
      }else{
        loadObject(num,json);
      }
      window['re_curvedTxt'+num+'_'+ReUnId].splice(-1);
      window['re_universal'+num].splice(-1);
      lastIndex = lastIndex.slice(6);
      universalFlow(num,lastIndex);
      object = window['canv_'+num].getActiveObject();
      textCurved(ReUnId,num,object);
    }
    jQuery('#undo').prop('disabled', false);
    jQuery('#redo').prop('disabled', false);
    if(window['re_universal'+num].length < 1){
      jQuery('#redo').prop('disabled', true);
    }
  }else{
    ReUnId = lastIndex.split(' id: ')[1];
    ReUnId = ReUnId.split(',')[0];
    json = window['re_textImage'+num+'_'+ReUnId].at(-1);
    Objects = window['canv_'+num].getObjects();
    if(firstC === 'done'){
      undoBtn.setAttribute('data-first','');
      Objects.forEach(function(obj){
        objId = obj.id;
        if(objId === ReUnId){
          textImage(ReUnId,num,obj);
        }
      });
      window['re_textImage'+num+'_'+ReUnId].splice(-1);
      json = window['re_textImage'+num+'_'+ReUnId].at(-1);
      loadObject(num,json);
    }
    if(addNew === 'addNew'){
      addObject(num,json);
      object = window['canv_'+num].getActiveObject();
      objNum = window['canv_'+num].getObjects().length - 1;
      setTimeout(function(){
        updateLayers(object,num,objNum);
      },10);
    }else{
      loadObject(num,json);
    }
    window['re_textImage'+num+'_'+ReUnId].splice(-1);
    window['re_universal'+num].splice(-1);
    lastIndex = lastIndex.slice(6);
    universalFlow(num,lastIndex);
    object = window['canv_'+num].getActiveObject();
    textImage(ReUnId,num,object);
    jQuery('#undo').prop('disabled', false);
    jQuery('#redo').prop('disabled', false);
    if(window['re_universal'+num].length < 1){
      jQuery('#redo').prop('disabled', true);
    }
  }
}

function re_universalFlow(num,lastIndex){
  var array = lastIndex;
  window['re_universal'+num].push(array);
}

function re_cColorState(num,reBase){
  window['re_cColor'+num].push(reBase);
}

function re_overlayState(num){
  window['re_overlayBg'+num].push(reChipName);
}

function re_backgroundState(num){
  window['re_canvasBgd'+num].push(reNewBg);
}

function re_chipRing(num){
  window['re_chipRing'+num].push(reNewRing);
}

function re_textCurved(id,num,object){
  window['re_curvedTxt'+num+'_'+id].push(object);
}

function re_textImage(id,num,object){
  window['re_textImage'+num+'_'+id].push(object);
}

function loadObject(num,json){
  object  = json;  
  type	  = object.type;
  objId   = object.id;
  leftT   = object.left;
  topT 	  = object.top;
  scaleXt = object.scaleX;
  scaleYt = object.scaleY;
  angleT  = object.angle;
  if(type === 'text' || type === 'curvedText'){
    txt 	  = object.text;
    base 	  = object.fill;
    font 	  = object.fontFamily;
    fontSize  = object.fontSize;
    bold 	  = object.fontWeight;
    italic	  = object.fontStyle;
    underline = object.textDecoration;
    alignment = object.textAlign;
    if(type === 'curvedText'){
      radiusT  = object.radius;
      spacingT = object.spacing;
      reverseT = object.reverse;
    }
  }else{
    imgSrc = object.src;
  }
  Objects  = window['canv_'+num].getObjects();
  activeOb = window['canv_'+num].getActiveObject();
  window['canv_'+num].discardActiveObject().renderAll();
  Objects.forEach(function(obj){
    id = obj.id;
    if(id === objId){
      obj.setTop(topT);
      obj.setScaleX(scaleXt);
      obj.setScaleY(scaleYt);
      obj.setAngle(angleT);
      if(obj.type === 'text' || obj.type === 'curvedText'){
        obj.setText(txt);
        obj.setFill(base);
        obj.setFontFamily(font);
        obj.setFontSize(fontSize);
        obj.setFontWeight(bold);
        obj.setFontStyle(italic);
        obj.setTextDecoration(underline);
        obj.setTextAlign(alignment);
        if(obj.type === 'curvedText'){
          obj.setRadius(radiusT);
          obj.setSpacing(spacingT);
          obj.setReverse(reverseT);
        }
      }     
      else if(obj.type === 'image'){
        obj.setSrc(imgSrc);
        window['canv_'+num].renderAll();
        jQuery('.layerObject.active>div>img').attr('src',imgSrc);
      }
      obj.setLeft(5);
      obj.setCoords();
      window['canv_'+num].renderAll();
      obj.setLeft(leftT);
      obj.setCoords();
      window['canv_'+num].renderAll();
    }
  });
  if(activeOb){
    window['canv_'+num].setActiveObject(activeOb);
  }
}

function addObject(num,json){
  object  = json;
  type	  = object.type;
  objId   = object.id;
  leftT   = object.left;
  topT 	  = object.top;
  scaleXt = object.scaleX;
  scaleYt = object.scaleY;
  angleT  = object.angle;
  if(type === 'text' || type === 'curvedText'){
    txt 	  = object.text;
    base 	  = object.fill;
    font 	  = object.fontFamily;
    fontSize  = object.fontSize;
    bold 	  = object.fontWeight;
    italic	  = object.fontStyle;
    underline = object.textDecoration;
    if(type === 'text'){
      alignment = object.textAlign;
      activeOb = new fabric.Text(txt,{
        textAlign: alignment
      });
    }            
    else{
      radiusT  = object.radius;
      spacingT = object.spacing;
      reverseT = object.reverse;
      activeOb = new fabric.CurvedText(txt,{
        effect: 'curved',
        radius: radiusT,
        spacing: spacingT,
        reverse: reverseT
      });
    }
    activeOb.set({
      fill: base,
      fontFamily: font,
      fontSize: fontSize,
      fontWeight: bold,
      fontStyle: italic,
      textDecoration: underline
    });
    window['canv_'+num].add(activeOb);
  }
  else{
    imgSrc = object.src;
    window['newImg_'+num] = new Image();
    activeOb = new fabric.Image(window['newImg_'+num],{
      width: object.width,
      height: object.height
    });
    window['canv_'+num].add(activeOb);
    window['newImg_'+num].src = imgSrc;
  }
  activeOb.set({
    originX: 'center',
    originY: 'center',
    id: objId,
    left: leftT,
    top: topT,
    scaleX: scaleXt,
    scaleY: scaleYt,
    angle: angleT
  });
  window['canv_'+num].setActiveObject(activeOb).renderAll();
}